import React from 'react'

import Stack from '@mui/material/Stack'

import LoadingGif from '../../../images/Loading.gif'

export interface CardLoadingProps {
  altLoadingText: string
}

export const CardLoading: React.FC<CardLoadingProps> = ({ altLoadingText }) => {
  return (
    <Stack
      sx={{
        alignItems: 'center',
      }}
    >
      <img
        alt={altLoadingText}
        src={LoadingGif}
        style={{
          marginBottom: 25,
          height: 64,
          width: 64,
        }}
      />
    </Stack>
  )
}
